module.exports = __webpack_public_path__ + "fonts/TBCSailec-Light.7643faa6.eot";